import { useTranslation } from "react-i18next";
import { LINKS, getLocalizedRoute } from "../../../config/links";
import { Cta, Header, Description, CtaButton, CtaImage, CtaImageWrapper, CtaWrapper } from "./styled";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";

const CTA = ({ variant, imagePosition = "right", image }) => {
    const { t, i18n } = useTranslation();
    const current = i18n.resolvedLanguage || i18n.language;

    const targetRoute = getLocalizedRoute(LINKS.routes[variant], current);

    return (
        <StaggeredContainer>
            <StaggeredItem>
                <CtaWrapper $imagePosition={imagePosition}>
                    <Cta>
                        <Header>{t(`cta.${variant}.header`)}</Header>
                        <Description>{t(`cta.${variant}.description`)}</Description>
                        <CtaButton to={targetRoute}>
                            {t(`cta.${variant}.button`)}
                        </CtaButton>
                    </Cta>

                    <CtaImageWrapper>
                        <CtaImage src={image} alt={t(`offer.items.${variant}.name`)} loading="lazy" />
                    </CtaImageWrapper>
                </CtaWrapper>
            </StaggeredItem>
        </StaggeredContainer>
    );
};

export default CTA;